The input parameter for the `updateUploadedCandidateProfileActions` mutation.
